
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streaming",
      function () {
        return require("private-next-pages/streaming.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streaming"])
      });
    }
  